import { Injectable, Inject } from "@angular/core";
import { HttpBackend, HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BaseFileService } from "./base-file.service";

@Injectable({
  providedIn: "root",
})
export class GenerateLinkService {
  baseUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient, handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  generateLink(values): any {
    let params = new HttpParams();

    if (values.categoryId)
      params = params.append("categoryId", values.categoryId);
    if (values.collectionId)
      params = params.append("collectionId", values.collectionId);
    if (values.brandId) params = params.append("brandId", values.brandId);

    let body = {
      dynamicLinkInfo: {
        domainUriPrefix: "https://app.trgatestore.com",
        link: `https://trgatestore.com/products?${params}`,
        androidInfo: {
          androidPackageName: "com.trgate.trgatestore",
        },
        iosInfo: {
          iosBundleId: "com.trgate.trgatestore",
        },
      },
    };
    if (values.productId)
      body = {
        dynamicLinkInfo: {
          domainUriPrefix: "https://app.trgatestore.com",
          link: `https://trgatestore.com/products/${values.productId}`,
          androidInfo: {
            androidPackageName: "com.trgate.trgatestore",
          },
          iosInfo: {
            iosBundleId: "com.trgate.trgatestore",
          },
        },
      };
    return this.httpClient.post<any>(
      `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBG9ndudMzHA56ZlVDLMviUz_DXICnpyRo`,
      body
    );
  }
}
